export default {
  setGoodTypes(state, value) {
    state.goodTypes = value
  },
  addGoodType(state, item) {
    state.goodTypes.push(item)
  },
  changeGoodType(state, item) {
    for (let i = 0; i < state.goodTypes.length; i++) {
      if (state.goodTypes[i].id === item.id) {
        state.goodTypes.splice(i, 1, item)
        break
      }
    }
  },
  removeGoodType(state, id) {
    for (let i = 0; i < state.goodTypes.length; i++) {
      if (state.goodTypes[i].id === id) {
        state.goodTypes.splice(i, 1)
        break
      }
    }
  },
}
